import {ReportType,} from '../types';
import {Stack} from '@mantine/core';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardProperty,
} from '@flexinet/ui-components';

export const Profile = ({record}: { record: ReportType }) => {

    const properties = [
        {
            label: 'Report Type ID',
            value: record.id as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        },
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        },
        {
            label: 'Version',
            value: record.version?.toString() as string,
            span: 12,
        },
        {
            label: 'Default Columns',
            value: record.defaultColumns?.join(', ') as string,
            span: 12,
        }];

    const properties2: PlatformPropertyCardProperty[] = [
        {
            label: 'Data Available Start',
            value: record.dataAvailableStartMillis,
            formatter: 'timestamp',
            span: 12,
        },
        {
            label: 'Data Available End',
            value: record.dataAvailableEndMillis,
            formatter: 'timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updatedMillis,
            formatter: 'timestamp',
            span: 12,
        }];


    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
